// extracted by mini-css-extract-plugin
export default {"root":"CustomDragPreview_root__f5-gR","icon":"CustomDragPreview_icon__Czwfw","label":"CustomDragPreview_label__QkUtD"};